import { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import TopStories from './components/TopStories';
import Features from './components/Features';
import Faq from './components/Faq';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const [query, setQuery] = useState('');
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleSearch = () => {
    document.getElementById('paoliao')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Header onSearch={handleSearch} />
      <main>
        <Hero
          query={query}
          onQueryChange={setQuery}
          onSearch={handleSearch}
        />
        <TopStories query={query} />
        <Features />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />

      {showTop && (
        <button
          type="button"
          aria-label="回到顶部"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950 text-background-50 shadow-lg transition-transform hover:-translate-y-1"
        >
          <i className="ri-arrow-up-line text-lg" />
        </button>
      )}
    </div>
  );
}